import http from "../http";
import ApiConstants from '../constants/ApiConstants';
import { TENANT, TenantService } from "../managers/TenantManagerService";
import PermissionUtils, { ACTION, MODULE } from "../components/user-permissions/PermissionUtils";

class PerformaceService {
    static ASSESSMENT = null;

    static getAppraisalCycle() {
        return http.get(`${ApiConstants.URL.BASE}${ApiConstants.URL.PERFORMANCE.APPRAISAL_LIST}`).catch(
            (error) => {
                console.error('Error fetching appraisal cycle: ', error);
                return Promise.reject(error);
            }
        );
    }

    static getReviewerAppraisalCycle() {
        return http.get(`${ApiConstants.URL.BASE}${ApiConstants.URL.PERFORMANCE.REVIEWER_APPRAISAL_LIST}`).catch(
            (error) => {
                console.error('Error fetching appraisal cycle: ', error);
                return Promise.reject(error);
            }
        );
    }

    static saveAppraisalCycle(body) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.PERFORMANCE.SAVE_APPRAISAL}`;
        return http.post(URL, body).catch(
            (error) => {
                console.error('Error saving appraisal cycle: ', error);
                return Promise.reject(error);
            }
        );
    }

    static updateAppraisalCycle(id, body) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.PERFORMANCE.SAVE_APPRAISAL}?appraisalId=${id}`;
        return http.put(URL, body).catch(
            (error) => {
                console.error('Error updating appraisal cycle: ', error);
                return Promise.reject(error);
            }
        );
    }

    static getAppraisalReviews(params) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.PERFORMANCE.APPRAISAL_REVIEWS}`;
        return http.get(URL, { params: params }).catch(
            (error) => {
                console.error('Error fetching appraisal cycle: ', error);
                return Promise.reject(error);
            }
        );
    }

    static getRatings() {
        return http.get(`${ApiConstants.URL.BASE}${ApiConstants.URL.PERFORMANCE.RATINGS}`).catch(
            (error) => {
                console.error('Error fetching ratings: ', error);
                return Promise.reject(error);
            }
        );
    }

    static getSelfAssessment(params) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.PERFORMANCE.SELF_ASSESSMENT}`;
        return http.get(URL, { params: params }).catch(
            (error) => {
                console.error('Error fetching self assessment: ', error);
                return Promise.reject(error);
            }
        );
    }

    static getAppraiserAssessment(params) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.PERFORMANCE.REVIEW_ASSESSMENT}`;
        return http.get(URL, { params: params }).catch(
            (error) => {
                console.error('Error fetching appraiser assessment: ', error);
                return Promise.reject(error);
            }
        );
    }

    static saveAppraiserAssessment(body) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.PERFORMANCE.REVIEW_ASSESSMENT}`;
        return http.post(URL, body).catch(
            (error) => {
                console.error('Error saving appraiser assessment: ', error);
                return Promise.reject(error);
            }
        );
    }

    static getAppraisalSettings() {
        return http.get(`${ApiConstants.URL.BASE}${ApiConstants.URL.PERFORMANCE.SETTINGS}`).catch(
            (error) => {
                console.error('Error fetching appraisal settings: ', error);
                return Promise.reject(error);
            }
        );
    }

    static saveSelfAssessment(body) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.PERFORMANCE.SELF_ASSESSMENT}`;
        return http.post(URL, body).catch(
            (error) => {
                console.error('Error saving self assessment: ', error);
                return Promise.reject(error);
            }
        );
    }

    static getGoals(param) {
        const url = TenantService.get(TENANT.IS_ADMIN) || TenantService.get(TENANT.IS_MANAGER) || PermissionUtils.hasAccess(MODULE.PERFORMANCE_GOAL,[ACTION.VIEW]) ? ApiConstants.URL.PERFORMANCE.GOALS : `${ApiConstants.URL.PERFORMANCE.GOALS}/employee` ;
        return http.get(url,{params:param}).catch(
            (error) => {
                console.error('Error fetching appraisal Goals: ', error);
                return Promise.reject(error);
            }
        );
    }

    static saveGoals(param) {
        return http.post(ApiConstants.URL.PERFORMANCE.GOALS,param).catch(
            (error) => {
                console.error('Error save appraisal Goals: ', error);
                return Promise.reject(error);
            }
        );
    }

    static updateGoals(param,id) {
        return http.patch(`${ApiConstants.URL.PERFORMANCE.GOALS}/${id}`,param).catch(
            (error) => {
                console.error('Error update appraisal Goals: ', error);
                return Promise.reject(error);
            }
        );
    }

    static deleteGoals(param) {
        return http.delete(ApiConstants.URL.PERFORMANCE.GOALS,{data:param}).catch(
            (error) => {
                console.error('Error deleting appraisal Goals: ', error);
                return Promise.reject(error);
            }
        );
    }

    static deleteAppraisalCycle(body) {
        const URL = `${ApiConstants.URL.PERFORMANCE.SETTINGS}`;
        return http.delete(URL, {data:body}).catch(
            (error) => {
                console.error('Error deleting appraisal cycle: ', error);
                return Promise.reject(error);
            }
        );
    }
}

export default PerformaceService;
